@if (chartData) {
  <p-chart type="bar" [data]="chartData"></p-chart>
}
